import { batch } from 'react-redux'
import { makeActionCreator } from '../../config/store/utils'
import { getAgilePurchaseInstitutions } from '../../services/agilePurchase'

export const AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS = 'AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS'
export const AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_SUCCESS = 'AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_SUCCESS'
export const AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_ERROR = 'AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_ERROR'

export const onGetAgilePurchaseTradedProductsInstitutions = makeActionCreator(
  AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS
)
export const onGetAgilePurchaseTradedProductsInstitutionsSuccess = makeActionCreator(
  AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_SUCCESS,
  'payload'
)
export const onGetAgilePurchaseTradedProductsInstitutionsError = makeActionCreator(
  AGILE_PURCHASE_TRADED_PRODUCTS_INSTITUTIONS_ERROR,
  'payload'
)

export const onGetAgilePurchaseTradedProductsInstitutionsThunk = payload => async dispatch => {
  dispatch(onGetAgilePurchaseTradedProductsInstitutions())
  try {
    const response = await getAgilePurchaseInstitutions({
      level: payload.level,
      heading: payload.heading,
      region: payload.region,
      year: payload.year
    })
    const data = response.data?.payload
    const formattedData = data
      .map(item => ({
        year: payload.year,
        entCode: item.entCode,
        amount: item.monto,
        amountUSD: item.montoUSD,
        heading: item.rubro,
        headingId: item.rubroId,
        region: item.region,
        regionId: item.idRegion,
        orders: item.cantidad,
        level: payload.level,
        institution: item.institucion
      }))
      .sort((a, b) => b.amount - a.amount)
      .slice(0, 10)

    const csvInstitutions =
      [
        ['Año', 'Región', 'Rubro', 'Institución', 'Monto Transado pesos chilenos', 'Monto Transado USD'],
        ...formattedData?.map(item => [
          payload.year,
          item.region,
          item.heading,
          item.institution,
          item.amount,
          item.amountUSD
        ])
      ] || []
    return batch(() => {
      dispatch(onGetAgilePurchaseTradedProductsInstitutionsSuccess({ institutions: formattedData, csvInstitutions }))
    })
  } catch (error) {
    dispatch(
      onGetAgilePurchaseTradedProductsInstitutionsError({
        error: 'Error al obtener datos',
        institutions: [],
        csvInstitutions: []
      })
    )
  }
}
